import { DataType, ICTTableCell, ICTTableGrid, ICTTableRow, ICTTransform2D, ITableData } from '@tencent/slide-sdk-model';
import { ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';

export const minRowHeight = ptToCanvas(30);
export const minColWidth = ptToCanvas(20);
export const defaultTableWidth = ptToCanvas(800);
export const defaultSlideWidth = ptToCanvas(960);

export class TableDefault {
    public static makeDefaultSdkData(
        left: number, top: number,
        width: number, height: number,
        rowCount: number, colCount: number,
    ): ITableData {
        const xfrm: ICTTransform2D = {
            off: {
                x: Math.round(left),
                y: Math.round(top),
            },
            ext: {
                cx: Math.round(width),
                cy: Math.round(height),
            },
        };
        const rowHeight = Math.round(height / rowCount);
        const colWidth = Math.round(width / colCount);
        const tblGrid: ICTTableGrid = {
            gridCol: [],
        };
        for (let i = 0; i < colCount; i++) {
            tblGrid.gridCol?.push({ w: colWidth });
        }
        const tr: ICTTableRow[] = [];

        for (let i = 0; i < rowCount; i++) {
            const row: ICTTableRow = {
                h: rowHeight,
                tc: [],
            };
            for (let j = 0; j < colCount; j++) {
                const col: ICTTableCell = {
                    txBody: {
                        bodyPr: {},
                        lstStyle: {},
                        p: [
                            {
                                egTextRun: [],
                                endParaRPr: {},
                            },
                        ],
                    },
                };
                row.tc?.push(col);
            }
            tr.push(row);
        }
        return {
            type: DataType.GraphicalObjectFrameTable,
            id: '',
            nvPr: {},
            spPr: {
                xfrm,
            },
            graphic: {
                graphicData: {
                    tbl: {
                        tblPr: {
                            tableStyleId: '{5C22544A-7EE6-4342-B048-85BDC9FD1C3A}',
                            firstRow: true,
                            bandRow: true,
                        },
                        tblGrid,
                        tr,
                    },
                },
            },
        };
    }
}
